import { render, staticRenderFns } from "./MortgageWatchCard.vue?vue&type=template&id=d603da56&scoped=true&"
import script from "./MortgageWatchCard.vue?vue&type=script&lang=js&"
export * from "./MortgageWatchCard.vue?vue&type=script&lang=js&"
import style0 from "./MortgageWatchCard.vue?vue&type=style&index=0&id=d603da56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d603da56",
  null
  
)

export default component.exports